import axios from 'axios';
import decode from 'jwt-decode';
import { setExpTime, clearExpDate, resetExpInSec } from '@/service/token-info-service'
import qs from 'query-string';
import cookies from 'vue-cookies'
import store from './../store';

const refreshTokenKey = 'refresh';
const accessTokenKey = 'Authorization';

const setTokens = ({ data }) => {

  setRefreshToken(data.refresh_token);
  setAccessToken(data.access_token);

  return data
}

export const refreshAxiosHeader = () => {

  var access_token = cookies.get(accessTokenKey)
  if (!access_token)
    return;

  axios.defaults.headers.common[accessTokenKey] = access_token;

}

export const setAccessToken = (accessToken) => {
  const authHeader = `Bearer ${accessToken}`;
  cookies.set(accessTokenKey, authHeader);
  refreshAxiosHeader()
}
export const setRefreshToken = (refreshToken) => {
  if (refreshToken) {
    cookies.set(refreshTokenKey, refreshToken)
    refreshAxiosHeader()
  }
}

export const setExpInMilSecByRefreshToken = (accessToken) => {
  const decToken = decode(accessToken);
  var time = ~~((decToken.exp * 1000 - Date.now()) / 1000)
  setExpTime(time);
  resetExpInSec()
}

export const refreshTokens = () =>
  axios.post('/v1/auth/token/refresh', qs.stringify({ refreshToken: cookies.get(refreshTokenKey) })).then(setTokens).catch(error => console.log("ERROR: " + JSON.stringify(error)));

export const login = (username, password) => axios.post('/v1/auth/login', qs.stringify({ username, password })).then(response => {
  setTokens(response)

  if (response.data.access_token)
    setExpInMilSecByRefreshToken(response.data.access_token)

  return response.data
});
export const logout = () => {
  var token = cookies.get(refreshTokenKey)
  if (token) {
    axios.post('/v1/auth/logout', qs.stringify({ token }))
  }

  cookies.remove(accessTokenKey);
  cookies.remove(refreshTokenKey);
  clearExpDate()

  cookies.remove(accessTokenKey);
  store.commit('userData/setIsFinallyAuthenticated', true);
}

export const isAuthenticated = () => {
  const refreshToken = cookies.get(refreshTokenKey);
  return !!refreshToken;
}

export const setup = () => isAuthenticated() && refreshTokens();

export const isFinallyAuthenticated = () => isAuthenticated && store.getters['userData/getIsFinallyAuthenticated'];
